import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import swal from 'sweetalert';
import Select from 'react-select';
import uuid from 'react-uuid';
import moment from 'moment';
import StatusBadge from '../common_component/StatusBadge.js';
import { useTheme } from "../includes/theme-provider.js"
import { getCookie } from '../common_component/cookie.js';
import { useModal } from '../providers/modal-provider.js';
import { useAuthData } from '../includes/auth-provider.js';
import { Tabs, Pagination, Button, Card, Tooltip, Typography, Upload, Checkbox } from "antd";
import { DeleteOutlined, UploadOutlined, DownloadOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

// modalData must have these attributes
// modalData = {
// 		//apiCallback: function | undefined,
// 		//modalCloseCallback: function | undefined,
// 		form_table_data: array,
// 		excel_for: string,
// 		disabledFields: array | undefined,
// 		page_name: string,
// }
export default function BulkUpdateModal() {
	const { theme, dropdownStyleDark } = useTheme()
	const history = useHistory();
	const fileSessionUniqueId = uuid();
	const { openModal, displayModal, modalData, closeModal, setModalData, setModalView } = useModal()
	const [bulkDataSubmitButtonState, setBulkDataSubmitButtonState] = useState(false)
	const [dataEntryMethod, setDataEntryMethod] = useState(null)
	const { write, organization_id } = useAuthData(modalData.page_name);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [validationOptions, setValidationOptions] = useState(["skip_duplicates", "skip_missing_required_fields",
		"skip_empty_rows"]);

	const [bulkData, setBulkData] = useState([]);
	const [bulkDataApiState, setBulkDataApiState] = useState(false)
	const apiController = useRef(new AbortController());
	const [listCount, setListCount] = useState(0)
	const [currentPage, setCurrentPage] = useState(1)
	const [rowsPerPage, setRowsPerPage] = useState(10)
	const [searchValue, setSearchValue] = useState(null)

	// Handle Excel file upload (prevent automatic upload)
	const handleChangeStatusExcel = ({ file }) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => {
			const base64 = reader.result.split(',')[1]; // remove data header
			setUploadedFile({
				name: file.name,
				type: file.type,
				data: base64
			});
		};
	};

	// Remove uploaded file
	const handleRemoveFile = () => {
		setUploadedFile(null);
	};

	const downloadExcelFile = (base64String, fileName) => {
		const link = document.createElement('a');
		link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`;
		link.download = fileName || 'template.xlsx';
		link.click();
	};

	const genTemplate = async () => {
		let object = {};
		object.excel_for = modalData.excel_for;
		object.data_entry_method = dataEntryMethod.value;
		object.organization_id = organization_id
		object.page_name = modalData.page_name;

		setBulkDataSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/download-excel-migration-template`, object, headers).then((res) => {
			setBulkDataSubmitButtonState(false)
			console.log(res.data)
			if (res.data.operation === "success") {
				const { fileContent, fileName } = res.data;
				downloadExcelFile(fileContent, fileName);
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const submitExcelBulkInformation = () => {
		// 1. Function to convert Base64 to Blob
		const base64ToBlob = (base64, type) => {
			const byteCharacters = atob(base64);
			const byteNumbers = new Array(byteCharacters.length);
			for (let i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
			const byteArray = new Uint8Array(byteNumbers);
			return new Blob([byteArray], { type: type });
		};

		const formData = new FormData();

		// 2. Convert your uploadedFile state back to a Blob
		if (uploadedFile && uploadedFile.data) {
			const fileBlob = base64ToBlob(uploadedFile.data, uploadedFile.type);
			// Append as a real file named 'file' to match backend upload.single('file')
			formData.append("file", fileBlob, uploadedFile.name);
		}

		// 3. Append other fields
		formData.append("unique_id", fileSessionUniqueId);
		formData.append("organization_id", organization_id);
		formData.append("page_name", modalData.page_name);
		formData.append("validation_options", JSON.stringify(validationOptions));
		formData.append("data_entry_method", dataEntryMethod.value);
		formData.append("excel_for", modalData.excel_for);
		formData.append("flag", "false");

		setBulkDataSubmitButtonState(true);

		const headers = {
			headers: {
				"Content-Type": "multipart/form-data",
				"token": getCookie("access_token")
			}
		};

		axios.post(`${process.env.REACT_APP_SERVER_URL}/submit-excel-bulk-information`, formData, headers)
			.then((res) => {
				setBulkDataSubmitButtonState(false);
				if (res.data.operation === "success") {
					swal("Great!", "Bulk data saved successfully.", "success").then(() => {
						window.location.reload();
					});
				} else {
					swal("Oops!", res.data.message || "Something went wrong!", "error");
				}
			})
			.catch((error) => {
				setBulkDataSubmitButtonState(false);
				console.error(error);
				swal("Error", "Server connection failed", "error");
			});
	};

	const handleBulkUploadModalClose = () => {
		modalData.modalCloseCallback?.()

		closeModal()
		setModalView(null)
		setModalData(null)
	}

	async function getBulkUploadList(cp, rpp, search_v) {
		try {
			if (bulkDataApiState) {
				apiController.current.abort()
				apiController.current = new AbortController()
			}
			setBulkDataApiState(true);
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-excel-bulk-information`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": modalData.email, excel_for: modalData.excel_for, "organization_id": modalData.organization_id, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "page_name": modalData.page_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();

			if (body.operation === "success") {
				setBulkData(body.data.list)
				setListCount(body.data.count)
			}
			setBulkDataApiState(false)
		}
		catch (err) {
			if (err.name !== 'AbortError') {
				console.log(err)
			}
		}
	}

	useEffect(() => {
		getBulkUploadList(currentPage, rowsPerPage, searchValue)
	}, [])

	useEffect(() => {
		getBulkUploadList(currentPage, rowsPerPage, searchValue)
	}, [currentPage, rowsPerPage, searchValue])

	const tabItems = [
		{
			key: '1',
			label: '📥 Data Entry',
			children: (
				<Card bordered style={{ padding: "5px" }}>
					<Title level={4}>Data Entry Method</Title>

					{/* Select Data Entry Method */}
					<Select
						style={{ width: "100%", marginBottom: 20 }}
						options={[
							{ label: "Insert New Data (Excel)", value: "insert_excel" },
							{ label: "Update Existing Data (Excel)", value: "update_excel" }
						]}
						onChange={(val) => setDataEntryMethod(val)}
						value={dataEntryMethod}
						placeholder="Select Data Entry Method"
						disabled={modalData?.disabledFields?.includes("data_entry_method") ?? false}
					/>

					{/* Excel Upload Section */}
					{dataEntryMethod !== null && dataEntryMethod.value !== "manual_entry" && (
						<>
							<Card type="inner" title="Excel Upload">
								<Text>Download the Excel template and upload your formatted data file.</Text>

								<div style={{ display: "flex", gap: "10px", margin: "20px 0" }}>
									<Button
										type="primary"
										icon={<DownloadOutlined />}
										onClick={genTemplate}
										loading={bulkDataSubmitButtonState}
										disabled={bulkDataSubmitButtonState}
									>
										Download Template
									</Button>

									<Upload
										maxCount={1}
										accept=".xlsx, .xls"
										beforeUpload={() => false}
										onChange={handleChangeStatusExcel}
										showUploadList={false}
									>
										<Button icon={<UploadOutlined />}>Upload Excel</Button>
									</Upload>
								</div>

								{uploadedFile !== null && (
									<Card style={{ marginTop: 10, backgroundColor: "#f5f5f5" }}>
										<Text strong>{uploadedFile.name}</Text>
										<Button
											type="link"
											icon={<DeleteOutlined />}
											onClick={handleRemoveFile}
											danger
										>
											Remove
										</Button>
									</Card>
								)}
							</Card>

							{/* Validation Options */}
							<div style={{ marginTop: 20 }}>
								<Text strong>Validation Options:</Text>
								<Checkbox.Group
									style={{ display: "flex", flexDirection: "column", marginTop: 10 }}
									onChange={(checkedValues) => setValidationOptions(checkedValues)}
									value={validationOptions}
								>
									<Checkbox value="skip_duplicates" disabled>Skip Duplicate Records</Checkbox>
									<Checkbox value="skip_missing_required_fields" disabled>Skip Missing Required Fields</Checkbox>
									<Checkbox value="skip_empty_rows" disabled>Skip Empty Rows</Checkbox>
								</Checkbox.Group>
							</div>
						</>
					)}
				</Card>
			),
		},
		{
			key: '2',
			label: '📄 Upload History',
			children: (
				<div className="card mb-5 mb-xl-8">
					<div className="card-body py-3">
						<div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
							{
								bulkDataApiState ? (
									<div className="spinner-border text-primary w-75px h-75px my-auto"></div>
								) : bulkData.length > 0 ? (
									<>
										<div className="mb-5 d-flex justify-content-center align-items-center gap-3">
											<button
												type="button"
												className="btn btn-light-primary btn-sm px-4"
												onClick={() => getBulkUploadList(currentPage, rowsPerPage, searchValue)}
												disabled={bulkDataApiState}
											>
												{bulkDataApiState ? (
													<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
												) : (
													<i className="fas fa-sync-alt me-2"></i>
												)}
												<span>Refresh</span>
											</button>
											<Pagination
												total={listCount}
												onChange={(page, pageSize) => {
													setCurrentPage(page);
													if (pageSize !== rowsPerPage) {
														setCurrentPage(1);
													}
													setRowsPerPage(pageSize);
												}}
												showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
												showQuickJumper
												pageSize={rowsPerPage}
												current={currentPage}
												showSizeChanger
											/>
										</div>

										<div className='overflow-auto w-100 flex-grow-1'>
											<table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace">
												<thead>
													<tr className="fw-bold text-muted">
														<th className="min-w-150px">Type</th>
														<th className="min-w-150px">Excel Link</th>
														<th className="min-w-150px">Status</th>
														<th className="min-w-150px">Timestamp</th>
													</tr>
												</thead>
												<tbody>
													{bulkData.map((obj) => (
														<tr key={obj.id}>
															<td><span className="text-dark fw-bold d-block mb-1 fs-6">{obj.data_entry_method.split('_')
																.map(word => word.charAt(0).toUpperCase() + word.slice(1))
																.join(' ')}</span></td>
															<td><a className="badge badge-primary" href={obj.excel_link}>Link</a></td>
															<td><StatusBadge status={obj.status} entity={""} />
																{(obj.status === "Failure" && obj.err_response) &&
																	<Tooltip title={`${obj.err_response.message}`}>
																		<i className="fa fa-info-circle mx-1 fs-4 text-hover-primary" style={{ cursor: "pointer" }} aria-hidden="true" ></i>
																	</Tooltip>}</td>
															<td>{moment(obj.add_date_time).format("lll")}</td>
														</tr>
													))}
												</tbody>
											</table>
										</div>

										<div className="mt-5 d-flex justify-content-center">
											<Pagination
												total={listCount}
												onChange={(page, pageSize) => {
													setCurrentPage(page);
													if (pageSize !== rowsPerPage) {
														setCurrentPage(1);
													}
													setRowsPerPage(pageSize);
												}}
												showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
												pageSize={rowsPerPage}
												current={currentPage}
												showSizeChanger
												showQuickJumper
											/>
										</div>
									</>
								) : (
									<div className="text-muted fs-2 my-auto text-center">No data to be shown</div>
								)
							}
						</div>
					</div>
				</div>
			)
		}
	];

	const goToManualEntry = () => {
		handleBulkUploadModalClose(); // Close modal first
		history.push({
			pathname: '/add-bulk-data',
			state: { excel_for: modalData.excel_for }
		});
	};

	return (
		<Modal show={displayModal} onHide={() => { handleBulkUploadModalClose() }} size="lg" centered>
			<Modal.Header>
				<Modal.Title>Bulk Data Entry - {modalData.excel_for}</Modal.Title>
				<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { handleBulkUploadModalClose() }}>
					<span className="svg-icon svg-icon-1">
						<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
							<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
								<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
								<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
							</g>
						</svg>
					</span>
				</div>
			</Modal.Header>
			<Modal.Body>
				<Tabs defaultActiveKey={modalData.default_active_key} items={tabItems} />
			</Modal.Body>
			<Modal.Footer>
				{window.location.href.split("/")[3].replace(/[^\w -]/g, '') !== "add-bulk-data" &&
					<a className="btn btn-primary rounded" onClick={goToManualEntry}
					>Manual Entry</a>}
				{
					write && (uploadedFile !== null) &&
					<>
						<button className="btn btn-success rounded" data-kt-indicator={bulkDataSubmitButtonState ? "on" : "off"} disabled={bulkDataSubmitButtonState}
							onClick={() => {
								if (dataEntryMethod !== null) {
									submitExcelBulkInformation()

								}
							}}>
							<span className="indicator-label">Submit</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						</button>
					</>
				}
				<button className="btn btn-secondary rounded" onClick={() => { handleBulkUploadModalClose() }}>Close</button>
			</Modal.Footer>
		</Modal>
	);
};
